<template>
  <div class="home">
    <div class="columns">
      <div class="column">
        <h2>ניהול מנויים</h2>
      </div>
      <div class="column has-text-left">
        <router-link :to="{name: 'refs'}"
        class="nav-btn button">עבור לניהול אפיליאייטס</router-link>
        <router-link :to="{name: 'cupons'}"
        class="nav-btn button">עבור לניהול קופונים</router-link>
        <router-link :to="{name: 'stats'}"
        class="nav-btn button">עבור לסטטיסטיקות</router-link>
      </div>
    </div>

    <subscribers :subs="$store.state.subList"></subscribers>
    <modal v-if="isModalOpen"></modal>
  </div>
</template>

<script>
import Subscribers from "@/components/Subscribers";
import Modal from "@/components/Modal.vue";

export default {
  name: "home",

  components: {
    Subscribers,
    Modal
  },

  computed: {
    isModalOpen() {
      return this.$store.state.modalShow;
    }
  },

  methods: {
    getInitialData() {
      this.$store.dispatch("getInitialData");
    }
  },
  created() {
    this.getInitialData();
  }
};
</script>

<style lang="scss">
.home {
  h2 {
    text-align: right;
    font-size: 28px;
    margin: 20px 0 10px;
  }

  .columns {
    margin-bottom: 0;
    &:not(:last-child) {
      margin-bottom: 0;
    }
  }
}

.nav-btn {
  margin-top: 30px;
  margin-right: 10px;
}
</style>

